export const DEFAULT_ERROR_CODE = 'common:registration.validation-errors.unhandled';

export const DEFAULT_PRICING_TABLE_NUMBER = 8;

export const DEFAULT_SSO_PROVIDER = 'google';

export const DEFAULT_PLAN = 'basic';

export const SSO_WINDOW_TARGET = 'google-sso';

export const REGISTRATION_STEP = 'registration';

export const REGISTER_STATE = 'register';

export enum SIGNUP_SOURCE {
  LOGIN_PAGE = 'login-page',
  DEMO_SITE = 'demo-site',
  DEMO_ACCOUNT_TRACKING_CODE = 'demo-account-tracking-code',
}

export const DEFAULT_CAMPAIGN_ID = 'a86dd6a983b5480dabf306c8f1f95b26';
